module.exports = __webpack_public_path__ + "img/Background7.debbb459.jpg";